/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Equipment_MissingInputs */

const en_us2_plan_equipment_missing = /** @type {(inputs: Plan_Equipment_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your gym does not have the equipment for that exercise.`)
};

const pt_br2_plan_equipment_missing = /** @type {(inputs: Plan_Equipment_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu local de treino não tem o equipamento desse exercício.`)
};

const es_419_plan_equipment_missing = /** @type {(inputs: Plan_Equipment_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu gimnasio no tiene el equipo para ese ejercicio.`)
};

const pt_pt2_plan_equipment_missing = /** @type {(inputs: Plan_Equipment_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu local de treino não tem o equipamento para esse exercício.`)
};

const fr_fr2_plan_equipment_missing = /** @type {(inputs: Plan_Equipment_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta salle n'a pas l'équipement pour cet exercice.`)
};

const de_de2_plan_equipment_missing = /** @type {(inputs: Plan_Equipment_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Studio hat nicht die Ausstattung für diese Übung.`)
};

const it_it2_plan_equipment_missing = /** @type {(inputs: Plan_Equipment_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua palestra non ha l'attrezzatura per quell'esercizio.`)
};

/**
* | output |
* | --- |
* | "Your gym does not have the equipment for that exercise." |
*
* @param {Plan_Equipment_MissingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_equipment_missing = /** @type {((inputs?: Plan_Equipment_MissingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Equipment_MissingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_equipment_missing(inputs)
	if (locale === "es-419") return es_419_plan_equipment_missing(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_equipment_missing(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_equipment_missing(inputs)
	if (locale === "de-DE") return de_de2_plan_equipment_missing(inputs)
	if (locale === "it-IT") return it_it2_plan_equipment_missing(inputs)
	return en_us2_plan_equipment_missing(inputs)
});
export { plan_equipment_missing as "plan.equipment_missing" }